<template>
  <div class="content-container">
    <div class="top-control-container">
      <div style="font-weight: 600">
        <p v-if="action !== 'create'" style="font-size: large">
          {{ formData?.booking_code }}
        </p>
        <p>
          Số tiền đã đặt cọc:
          {{ Intl.NumberFormat().format(depositedMoney) }}
        </p>
      </div>

      <div class="button-containers">
        <button
          v-if="action != 'view'"
          class="btn primary medium"
          @click="onClickSaveBooking"
        >
          Lưu
        </button>
        <button
          class="btn primary medium outline"
          @click="onOpenBookingDepositDialog"
        >
          Đặt cọc
        </button>
        <!-- <button class="btn primary medium outline">Routing</button> -->
        <button class="btn primary medium outline" @click="onNavigateBack()">
          Quay lại
        </button>
      </div>
    </div>
    <div>
      <Tab
        v-model="tabIndex"
        class="tabmenu-container-custom"
        :tab-list="tabList"
      />
    </div>
    <!-- RESERVATION TAB -->
    <template v-if="isHydrated">
      <div v-show="tabIndex === 1" class="tab-content">
        <BookingFormCustomerTab
          ref="BookingFormCustomerTab"
          :visible="tabIndex"
          :booking-travelers="formData.booking_traveller"
          @onAddCustomerToBooking="onAddCustomerToBooking"
          @onUpdateCustomer="onUpdateCustomer"
          @removeCustomerFromBooking="onRemoveCustomerFromBooking"
          @bookingMasterChanged="onBookingMasterChanged"
        ></BookingFormCustomerTab>
      </div>
      <div v-show="tabIndex === 2" class="tab-content">
        <!-- :key="dataKey" -->
        <new-group-master
          ref="BookingFormBookingTab"
          :action="action"
          :booker="formData.booker"
          :booking-record="formData"
          @bookerSelected="onBookerSelected"
          @bookerRemoved="onBookerRemoved"
        ></new-group-master>
        <!-- @agencySelected="onAgencySelected" -->
      </div>

      <el-dialog
        width="900px"
        :visible="isBookingDepositDialogOpened"
        title="Thêm đặt cọc cho đặt phòng"
        @close="onCloseBookingFormDepositDialog"
      >
        <div>
          <BookingFormDepositDialog
            ref="BookingFormDepositDialog"
            :booking-group-id="bookingId"
          ></BookingFormDepositDialog>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small"
              @click="onCloseBookingFormDepositDialog"
            >
              Đóng
            </button>
            <button class="btn primary small outline" @click="onCreateDeposit">
              Đặt cọc
            </button>
          </div>
        </div>
      </el-dialog>
    </template>
    <div v-else class="tab-content"></div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '@/components/Tab'
import { createBookingDeposit } from '@/api/booking_service/deposit'
import newGroupMaster from '../newGroupMaster.vue'
import BookingFormDepositDialog from '@/components/resources/booking/BookingFormDepositDialog.vue'
import BookingFormCustomerTab from '@/components/resources/booking/BookingFormCustomerTab.vue'
// import BookingFormAdditionalInfoTab from '@/components/resources/booking/BookingFormAdditionalInfoTab.vue'

import {
  getRoomAvaiSubGroupApi,
  getPriceCodeApi,
  addGroupApi,
  updateGroupApi,
  getConfirmCodeApi,
  getGroupByIdApi,
  getRoomRowApi
} from '@/api/booking_service/bookingGroup'
import { getBooking, updateBooking } from '@/api/booking_service/bookingGroup'
import { getTravellerByIdApi } from '@/api/configuration/profile/traveller'
import { notifyError, notifySuccess } from '@/utils/toast'
import { getAllCurrencyApi } from '@/api/common/currency'
import { getGroupDepositAmount } from '@/api/booking_service/booking-balance'
export default {
  components: {
    Tab,
    newGroupMaster,
    BookingFormCustomerTab,
    BookingFormDepositDialog
  },
  props: {
    action: {
      required: true,
      default: 'create',
      validator: value => {
        return ['create', 'edit', 'view'].includes(value)
      }
    },
    bookingId: null
  },
  data() {
    return {
      depositedMoney: null,
      dataKey: 0,
      isHydrated: false,
      isBookingRoomDialogOpened: false,
      isBookingDepositDialogOpened: false,
      bookingRoomFormData: null,
      bookingRoomTableIndex: null,
      bookingRoomFormAction: 'create',
      formData: {
        booker: {
          id: null,
          name: null,
          phone: '',
          email: null,
          first_name: null,
          last_name: null
        },
        color: null,
        name: null,
        note: null,
        first_arrival_date: this.$moment().format('YYYY-MM-DD'),
        last_departure_date: this.$moment().add(1, 'd').format('YYYY-MM-DD'),
        numb_of_night: 1,
        agent_id: null,
        business_man_id: null,
        agent_id_2: null,
        debit_account_id: null,
        no_price_printing: true,
        no_extra_service: true,
        pay_method: null,
        vehicles: [],
        arriving_time: null,
        leaving_time: null,
        special_services: [],
        sub_booking_groups: [],
        market_seg_id: null,
        source_id: null,
        contacts: [],
        comment: [],
        status: 1,
        booking_traveller: [],
        booking_room: [],
        deposit: null
      },
      tabIndex: 2,
      tabList: [
        { label: 'Khách', value: 1 },
        { label: 'Thông tin đoàn', value: 2 }
      ],
      titleOptions: [
        { label: 'Mr', value: 'Mr' },
        { label: 'Mrs', value: 'Mrs' },
        { label: 'Ms', value: 'Ms' }
      ]
    }
  },
  computed: {},
  async created() {
    this.isHydrated = false
    if (this.bookingId != null) {
      await this.getBookingGroup(this.bookingId)
      await getGroupDepositAmount(this.bookingId)
        .then(res => {
          this.depositedMoney = res?.data ?? 0
        })
        .catch(err => {
          const message = err?.response?.data?.message
          this.$message({
            type: 'error',
            message: message ?? 'Đã có lỗi xảy ra khi lấy thông tin đặt cọc'
          })
        })
    }
    this.isHydrated = true
  },
  methods: {
    onSelectDuplicateCustomer() {},
    // onAgencySelected(id) {
    //   this.formData.additional_info.agent_id = id
    // },
    onOpenBookingDepositDialog() {
      this.isBookingDepositDialogOpened = true
      this.$nextTick(() => {
        this.$refs.BookingFormDepositDialog.hydrateForm()
      })
    },
    onOpenUpdateBookingRoom() {
      this.bookingRoomFormAction = 'edit'
      this.isBookingRoomDialogOpened = true
    },
    onOpenCreateBookingRoom() {
      this.bookingRoomFormData = null
      this.bookingRoomTableIndex = null
      this.bookingRoomFormAction = 'create'
      this.isBookingRoomDialogOpened = true
    },
    async onClickSaveBooking() {
      let error = null
      let error2 = null
      // error = this.$refs.BookingFormBookingTab.validateAdditionalInfoForm()
      error = await this.$refs.BookingFormBookingTab.validateBookerFormData()
      error2 = await this.$refs.BookingFormBookingTab.validateVehicleFormData()
      // log
      if (!error) {
        return
      }
      if (error2) {
        notifyError(error2, true)
        return
      }

      // const additionalInfoTabBookingInfo =
      //   this.$refs.BookingFormAdditionalInfoTab.dehydrateBookingFrom()
      // const additionalInfo =
      //   this.$refs.BookingFormAdditionalInfoTab.dehydrateForm()
      // const bookingAdditionalInfo =
      //   this.$refs.BookingFormBookingTab.dehydrateAdditionalInfoForm()
      const bookingForm =
        await this.$refs.BookingFormBookingTab.dehydrateFormData()
      Object.assign(this.formData, bookingForm)
      // Object.assign(this.formData, additionalInfoTabBookingInfo)
      // // Object.assign(this.formData.additional_info, additionalInfo)
      // // Object.assign(this.formData.additional_info, bookingAdditionalInfo)
      if (this.bookingId) {
        this.updateBookingGroup()
      } else {
        this.createBookingGroup()
      }
    },
    async updateBookingGroup() {
      const payload = {}
      Object.assign(payload, this.formData)

      await updateGroupApi(this.bookingId, payload)
        .then(response => {
          notifySuccess(response?.message)
        })
        .then(() => {
          this.$router.push('/group/group_master_functions')
        })
        .catch(error => {
          notifyError(error?.response?.data?.message)
        })
    },
    async createBookingGroup() {
      await addGroupApi(this.formData)
        .then(response => {
          notifySuccess(response?.message)
        })
        .then(() => {
          this.$router.push('/group/group_master_functions')
        })
        .catch(error => {
          notifyError(error?.response?.data?.message)
        })
    },
    onUpdateCustomer(updatedCustomer) {
      this.formData.booking_traveller.find(customer => {
        if (customer.traveller_id === updatedCustomer.traveller_id) {
          console.debug('updatedCustomer', updatedCustomer)
          Object.assign(customer, updatedCustomer)
          this.refreshBookingTravellerTable()
          return true
        }
      })
    },
    onBookerRemoved(booker) {
      const masterTraveller = this.formData.booking_traveller.find(
        traveller => traveller.traveller_id === booker.id
      )
      if (masterTraveller != null) {
        masterTraveller.is_master = false
      }
      this.formData.booker.id = null
      this.formData.booker.last_name = null
      this.formData.booker.first_name = null
      this.formData.booker.phone = null
      this.formData.booker.email = null
      this.$refs.BookingFormBookingTab.hydrateBookerFormData(this.formData)
      this.refreshBookingTravellerTable()
    },
    onBookerSelected(booker) {
      this.formData.booking_traveller.forEach(traveller => {
        if (traveller.traveller_id === booker.id) {
          traveller.is_master = true
        } else {
          traveller.is_master = false
        }
      })
      this.formData.booker.id = booker.id
      this.formData.booker.last_name = booker.last_name
      this.formData.booker.first_name = booker.first_name
      this.formData.booker.phone = booker.phone
      this.formData.booker.email = booker.email
      this.refreshBookingTravellerTable()
    },
    onCloseBookingFormDepositDialog() {
      this.$refs.BookingFormDepositDialog.hydrateForm()
      this.isBookingDepositDialogOpened = false
    },
    async onCreateDeposit() {
      const error = this.$refs.BookingFormDepositDialog.validateFormData()
      if (error) {
        notifyError(error, true)
        return
      }
      // TODO: Extract submit logic from this form
      const payload = await this.$refs.BookingFormDepositDialog.dehydrateForm()
      if (this.bookingId != null) {
        await createBookingDeposit(payload)
          .then(res => {
            this.$message({
              type: 'success',
              message: 'Đã đặt cọc thành công'
            })
          })
          .catch(err => {
            const message = err?.response?.data?.message
            this.$message({
              type: 'error',
              message: message ?? 'Đã có lỗi xảy ra'
            })
          })
        await getGroupDepositAmount(this.bookingId)
          .then(res => {
            this.depositedMoney = res?.data ?? 0
          })
          .catch(err => {
            const message = err?.response?.data?.message
            this.$message({
              type: 'error',
              message: message ?? 'Đã có lỗi xảy ra'
            })
          })
      } else {
        // Submit deposit along with payload when create new booking
        this.formData.deposit = payload
        this.depositedMoney = payload.deposit_money

        this.$message({
          type: 'success',
          message: 'Đã thêm đặt cọc'
        })
      }
      this.$refs.BookingFormDepositDialog.hydrateForm()
      this.isBookingDepositDialogOpened = false
    },
    onRemoveCustomerFromBooking(customerId) {
      const travellerIndex = this.formData.booking_traveller.findIndex(
        traveller =>
          traveller.id === customerId || traveller.traveller_id === customerId
      )
      if (travellerIndex !== -1) {
        this.formData.booking_traveller.splice(travellerIndex, 1)
      }
    },
    onAddCustomerToBooking(customer) {
      const existingCustomer = this.formData.booking_traveller.find(
        bookingCustomer => bookingCustomer.traveller_id === customer.id
      )
      if (existingCustomer) {
        this.$message({
          type: 'error',
          message: 'Khách hàng đã nằm trong danh sách'
        })
        return
      }

      this.formData.booking_traveller.push({
        traveller_id: customer.id,
        first_name: customer.first_name,
        last_name: customer.last_name,
        phone: customer.phone_number,
        is_master: false,
        note: customer.note
      })

      this.$refs.BookingFormCustomerTab.hydrateCustomerForm()
    },
    async onBookingMasterChanged(colName, params, value) {
      const changedIndex = params.rowIndex
      this.formData.booking_traveller.forEach((traveller, index) => {
        if (index === changedIndex) {
          traveller.is_master = value
        } else {
          traveller.is_master = false
        }
      })

      if (value === true) {
        await this.updateBooker(params.data.traveller_id)
      } else {
        this.onBookerRemoved(params.data)
      }

      this.refreshBookingTravellerTable()
    },
    refreshBookingTravellerTable() {
      this.$refs.BookingFormCustomerTab.$refs.agGrid.gridOptions.api.refreshCells(
        {
          force: true
        }
      )
    },
    dehydrateDepositForm() {
      const payload = {
        booking_traveller: []
      }

      const booking_traveller = []
      booking_traveller.push({
        note: null,
        traveller_id: this,
        is_master: true
      })
      payload.booking_traveller = booking_traveller
    },
    async updateBooker(customerId) {
      const customer = await this.getCustomer(customerId)
      this.formData.booker.id = customer.id
      this.formData.booker.name = customer.name
      this.formData.booker.first_name = customer.first_name
      this.formData.booker.last_name = customer.last_name
      this.formData.booker.email = customer.email
      this.formData.booker.phone = customer.phone_number
      this.dataKey++
    },
    async getCustomer(customerId) {
      const traveller = await getTravellerByIdApi({
        id: customerId
      })
        .then(response => {
          notifySuccess(response?.message)
          return response.data
        })
        .catch(err => {
          notifyError(err.response?.data?.message)
          return null
        })
      return traveller
    },

    onNavigateBack() {
      this.$router.push('/group/group_master_functions')
    },
    hydrateTab(index) {
      if (this.tabIndex === 1) {
        this.hydrateAdditionalInfoTab()
      } else if (this.tabIndex === 2) {
        this.hydrateBookingTab()
      } else if (this.tabIndex === 3) {
        this.hydrateCustomerTab()
      }
    },
    hydrateAdditionalInfoTab() {},
    hydrateBookingTab() {},
    hydrateCustomerTab() {},
    async getBookingGroup(bookingId) {
      const booking = await getGroupByIdApi(bookingId)
        .then(res => {
          return res.data
        })
        .catch(err => {
          const message = err?.response?.data?.message ?? 'successMsg.default'
          this.$message({
            type: 'error',
            message: message
          })
        })
      this.formData = { ...booking }
    }
  }
}
</script>
<style scoped>
.content-container .top-control-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
